import { LatestNotification, LocalDate, SCode } from '../../..';

// TODO make base class when all app will be with LocalDate interface
export class PlannedTimeModel {
  statusCode: SCode = null;
  statusCodeDescription: string;
  plannedDepartureTime: LocalDate;
  plannedArrivalTime: LocalDate;
  transactionDateTime: LocalDate;
  latestNotification: LatestNotification;

  constructor(params?: PlannedTimeModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
